import {getAllDeliveryChallans} from '../../services/DeliveryChallanServices'
import Swal from "sweetalert2";
import { getHTMLForSummaryPopup } from '../../utils/PopupUtils';
import {displayError, flattenErrorMessage, parseBooleanToString} from '../../helpers';
import { navigateWithReturn } from '../../utils/returnNavigation';
import { getMoistureByPlant } from '../../services/MoistureCorrectionServices';
import { getAllPlantConfigurations } from '../../services/PlantConfigurationServices';
import { getBinMoistureDisplayRows, toNumber } from '../../utils/designMixMoistureUtils';

export function checkForDuplicateDeliveryChallans(name, value, cookies, existingId) {
    
    
    let nameCheck = new Promise((resolve, reject) => {
      getAllDeliveryChallans(cookies)
      .then((data) => {

        let isUserExists = false;
        for(var i=0; i<data.salesrep_data.length; i++)    //Same Sales Representative Name mentioned it denoted already exist.
        {
          if((data.salesrep_data[i].entity_name) === value.trim().toUpperCase()
            && parseInt(existingId) !== data.salesrep_data[i].id){   
            
            console.log(`User exists with the name - ${value}`) 
            isUserExists = true;
            break;
          }
        }
        resolve(isUserExists);
      });  
    });

    return nameCheck;
  }

function formatPopupNumber(value, digits = 2) {
  const num = toNumber(value);
  if (digits === 0) {
    return String(Math.round(num));
  }
  if (Number.isInteger(num)) {
    return String(num);
  }
  return num.toFixed(digits);
}

function getDesignMixGradeName(designmix_list) {
  return designmix_list?.design_mix_list?.[0]?.work_schedule?.sales_order_detail?.product?.name || '';
}

function resolvePlantId({ plantId, plantConfig, designmix_list }) {
  if (plantId) return plantId;
  const designMix = designmix_list?.design_mix_list?.[0];
  return (
    designMix?.work_schedule?.entity_plant_id
    || designMix?.work_schedule?.plant?.id
    || plantConfig?.plant_configuration_list?.[0]?.plant
    || plantConfig?.plant
    || null
  );
}

function resolvePlantConfiguration(plantConfig) {
  if (!plantConfig) {
    return null;
  }
  if (Array.isArray(plantConfig)) {
    return plantConfig[0] || null;
  }
  if (plantConfig.plant_configuration_list?.[0]) {
    return plantConfig.plant_configuration_list[0];
  }
  if (plantConfig.bin_1 !== undefined || plantConfig.silo_1 !== undefined || plantConfig.is_bin_1 !== undefined) {
    return plantConfig;
  }
  return null;
}

/** Compact horizontal moisture-correction table for DC / Work Schedule Design Mix popup. */
function buildDesignMixMoistureTableHtml(plantConfiguration, designMix, moistureCorrection, gradeName) {
  const binRows = getBinMoistureDisplayRows(plantConfiguration, moistureCorrection, designMix)
    .filter((bin) => bin.enabled);
  let totalCorrectionKg = 0;

  const tableRows = [];

  const addPlainRow = (label, recipe, opts = {}) => {
    const recipeValue = toNumber(recipe);
    tableRows.push({
      material: label,
      recipe: formatPopupNumber(recipeValue),
      moisture: '—',
      cf_pct: '—',
      cf_value: '—',
      target: formatPopupNumber(recipeValue),
      ...opts,
    });
  };

  for (let i = 1; i <= 5; i += 1) {
    if (!plantConfiguration[`is_silo_${i}`]) continue;
    addPlainRow(plantConfiguration[`silo_${i}`] || `Cem${i}`, designMix[`cem${i}`]);
  }
  if (designMix.total_cem != null) {
    addPlainRow('Total Cementitious', designMix.total_cem, { isCalculated: true });
  }

  binRows.forEach((bin) => {
    totalCorrectionKg += toNumber(bin.correctionKg);
    tableRows.push({
      material: bin.label || bin.materialKey,
      recipe: formatPopupNumber(bin.designValue),
      moisture: formatPopupNumber(bin.moisture),
      cf_pct: formatPopupNumber(bin.correctionFactor),
      cf_value: formatPopupNumber(bin.correctionKg),
      target: formatPopupNumber(bin.correctedTarget),
      isAggregate: true,
    });
  });

  const waterAdjKg = -totalCorrectionKg;
  for (let i = 1; i <= 2; i += 1) {
    if (!plantConfiguration[`is_other_${i}`]) continue;
    const recipe = toNumber(designMix[`water${i}`]);
    const target = recipe > 0 ? recipe + waterAdjKg : recipe;
    tableRows.push({
      material: plantConfiguration[`other_${i}`] || `Water ${i}`,
      recipe: formatPopupNumber(recipe),
      moisture: '—',
      cf_pct: '—',
      cf_value: formatPopupNumber(recipe > 0 ? waterAdjKg : 0),
      target: formatPopupNumber(target),
      isWater: true,
    });
  }
  for (let i = 3; i <= 5; i += 1) {
    if (!plantConfiguration[`is_other_${i}`]) continue;
    const field = i === 3 ? 'adm1' : i === 4 ? 'adm2' : 'others';
    addPlainRow(plantConfiguration[`other_${i}`] || `Other ${i}`, designMix[field]);
  }

  const columns = [
    { key: 'material', label: 'Material', align: 'left' },
    { key: 'recipe', label: 'Recipe', align: 'right' },
    { key: 'moisture', label: 'Moisture Correction', align: 'right' },
    { key: 'cf_pct', label: 'Correction Factor %', align: 'right' },
    { key: 'cf_value', label: 'Correction Factor Value', align: 'right' },
    { key: 'target', label: 'Target Value', align: 'right' },
  ];

  const metaBits = [];
  if (gradeName) metaBits.push(`Grade: <b>${gradeName}</b>`);
  if (moistureCorrection?.mc_no) metaBits.push(`MC: <b>${moistureCorrection.mc_no}</b>`);
  if (moistureCorrection?.mc_date_display || moistureCorrection?.mc_date) {
    metaBits.push(`Date: <b>${moistureCorrection.mc_date_display || moistureCorrection.mc_date}</b>`);
  }
  if (moistureCorrection?.id == null) {
    metaBits.push('<span style="color:#b45309">No active moisture correction — showing zeros until next MC is created</span>');
  }

  const th = columns.map((c) => (
    `<th style="position:sticky;top:0;z-index:1;padding:6px 8px;border:1px solid #94a3b8;background:#0d6efd;color:#fff;font-size:12px;white-space:nowrap;text-align:center;">${c.label}</th>`
  )).join('');

  const tr = tableRows.map((row) => {
    const bg = row.isAggregate ? '#fffbeb' : row.isWater ? '#ecfeff' : row.isCalculated ? '#eff6ff' : '#fff';
    const weight = row.isCalculated ? 'font-weight:700;color:#1d4ed8;' : '';
    return `<tr>${columns.map((c) => (
      `<td style="padding:5px 8px;border:1px solid #cbd5e1;background:${bg};font-size:12px;text-align:${c.align};white-space:nowrap;${weight}">${row[c.key] ?? ''}</td>`
    )).join('')}</tr>`;
  }).join('');

  return `
  <div style="text-align:left">
    <div style="padding:8px 10px;background:#0d6efd;color:#fff;font-size:14px;font-weight:700;border-radius:6px 6px 0 0;">
      DESIGN MIX LIST
    </div>
    ${metaBits.length ? `<div style="padding:6px 10px;background:#eef6ff;border:1px solid #bfdbfe;border-top:0;font-size:12px;color:#1e3a8a;">${metaBits.join(' &nbsp;|&nbsp; ')}</div>` : ''}
    <div style="max-height:55vh;overflow:auto;border:1px solid #94a3b8;border-top:0;border-radius:0 0 6px 6px;">
      <table width="100%" cellspacing="0" cellpadding="0" style="border-collapse:collapse;min-width:720px;">
        <thead><tr>${th}</tr></thead>
        <tbody>${tr}</tbody>
      </table>
    </div>
    <div style="margin-top:6px;font-size:11px;color:#64748b;">
      CF% = Moisture − Absorption &nbsp;·&nbsp; Aggregate Target = Recipe + CF(Kg) &nbsp;·&nbsp; Water Target = Recipe − total CF(Kg)
    </div>
  </div>`;
}

export function showDmixPopup(designmix_list, plantConfig, moistureCorrection = null) {
  const plant_configuration = resolvePlantConfiguration(plantConfig);
  const design_mix = designmix_list?.design_mix_list?.[0];
  if (!plant_configuration || !design_mix) {
    Swal.fire('Design mix is not available.', '', 'info');
    return;
  }
  const html = buildDesignMixMoistureTableHtml(
    plant_configuration,
    design_mix,
    moistureCorrection,
    getDesignMixGradeName(designmix_list),
  );
  Swal.fire({
    html,
    width: '920px',
    confirmButtonText: 'Close',
    customClass: { popup: 'dmix-moisture-popup' },
  });
}

export async function openDesignMixPopup({ cookies, designmix_list, plantConfig, plantId }) {
  const design_mix = designmix_list?.design_mix_list?.[0];
  if (!design_mix) {
    Swal.fire('Design mix is not available.', '', 'info');
    return;
  }

  let resolvedConfig = resolvePlantConfiguration(plantConfig);
  const resolvedPlantId = resolvePlantId({ plantId, plantConfig, designmix_list });

  try {
    if (!resolvedConfig && cookies && resolvedPlantId) {
      const configResponse = await getAllPlantConfigurations(cookies, resolvedPlantId);
      resolvedConfig = resolvePlantConfiguration(configResponse);
    }
  } catch (err) {
    // keep resolvedConfig as-is
  }

  if (!resolvedConfig) {
    Swal.fire('Plant configuration is not available for this design mix.', '', 'info');
    return;
  }

  let moisture = null;
  try {
    if (cookies && resolvedPlantId) {
      moisture = await getMoistureByPlant(cookies, resolvedPlantId);
    }
  } catch (err) {
    moisture = null;
  }

  showDmixPopup(
    designmix_list,
    { plant_configuration_list: [resolvedConfig] },
    moisture,
  );
}

/** Own vehicle selected, or customer vehicle number entered. */
export function isDcVehicleReady(inputs = {}, selectedVehicle = null) {
  if (String(inputs.transport_mode || '').toLowerCase() === 'customer') {
    return Boolean((inputs.customer_vehicle_no || '').trim());
  }
  const raw = selectedVehicle?.value ?? selectedVehicle;
  const id = parseInt(raw, 10);
  return Number.isFinite(id) && id > 0;
}

export function getDcVehicleDisplayNo(inputs = {}, selectedVehicle = null) {
  if (String(inputs.transport_mode || '').toLowerCase() === 'customer') {
    return (inputs.customer_vehicle_no || '').trim() || '—';
  }
  return selectedVehicle?.label || '—';
}

export function getDcConfirmContext({
  selectedWorkSchedule = {},
  inputs = {},
  selectedVehicle = null,
  finishedgoods = [],
} = {}) {
  const so = selectedWorkSchedule?.sales_order_detail?.sales_order || {};
  const consignee = so.consignee || {};
  const gradeFromWs = selectedWorkSchedule?.sales_order_detail?.product?.name || '';
  const gradeOption = (finishedgoods || []).find(
    (item) => String(item.value) === String(inputs.production_grade_id || inputs.dc_grage_id || ''),
  );
  return {
    customer: consignee?.customer?.name || '',
    site: consignee?.project_name || consignee?.name || '',
    grade: gradeFromWs || gradeOption?.label || '',
    vehicleNo: getDcVehicleDisplayNo(inputs, selectedVehicle),
    qty: inputs.dc_qty ?? 0,
    cumulativeQty: inputs.cumulative_quantity ?? 0,
  };
}

export function buildDcSaveConfirmHtml(context = {}, { actionLabel = 'save' } = {}) {
  const rows = [
    ['Customer', context.customer || '—'],
    ['Site', context.site || '—'],
    ['Grade', context.grade || '—'],
    ['Vehicle No', context.vehicleNo || '—'],
    ['Qty', context.qty ?? 0],
    ['Cumulative Qty', context.cumulativeQty ?? 0],
  ];
  const body = rows.map(([label, value]) => (
    `<tr>
      <td style="padding:6px 10px;text-align:right;font-weight:700;width:42%;border-bottom:1px solid #e2e8f0;">${label}</td>
      <td style="padding:6px 10px;text-align:left;border-bottom:1px solid #e2e8f0;">${value}</td>
    </tr>`
  )).join('');
  return `
    <div style="text-align:left">
      <table width="100%" style="border-collapse:collapse;font-size:14px;margin-bottom:8px;">
        ${body}
      </table>
      <div style="margin-top:8px;font-size:13px;color:#334155;">Do you want to ${actionLabel} this Delivery Challan?</div>
    </div>`;
}

export function promptSelectVehicleBeforeQty() {
  Swal.fire('Vehicle Required', 'Please select Vehicle No before entering quantity.', 'info');
}

export function showBillingPop(selectedCustomer){
    Swal.fire({
      html:getHTMLForSummaryPopup(
          'BILLING DETAILS',
          [
            {label: 'BILLING NAME', value: selectedCustomer.name},
          {label: 'ADDRESS', value: selectedCustomer.address_1},
          {value: selectedCustomer.address_2},
          {value: selectedCustomer.address_3},
          {label: 'SALES OFFICER', value: selectedCustomer.salesrep.name},
          
          ])
  }, '', 'info');
  }
  export function showCustomerSitePop(consignee){
    Swal.fire({
      html:getHTMLForSummaryPopup(
          'DELIVERY DETAILS',
          [
            {label: 'DELIVERY NAME', value: consignee.name},
            {label: 'ADDRESS', value: consignee.address_1},
            {value: consignee.address_2},
            {value: consignee.address_3},
          ])
  }, '', 'info');   

  }
  export function showWorkschedulePop(selectedWorkSchedule){
    Swal.fire({
      html:getHTMLForSummaryPopup(
          'WORKSCHEDULE DETAILS',
          [
          
          {label: 'WORK ORDER NO.', value: selectedWorkSchedule.schedule_no},
          {label: 'WORK ORDER DATE', value: selectedWorkSchedule.schedule_date},
          {label: 'MODE OF DELIVERY', value: selectedWorkSchedule.sales_order_detail.delivery_mode},
          {label: 'PUMP NO', value: selectedWorkSchedule.pump.name},
          {label: 'GANG', value: selectedWorkSchedule.gang.name},
          {label: 'IS EXTRA CHUTE REQUIRED?', value: parseBooleanToString(selectedWorkSchedule.is_extra_shut_required)},
          
          ])
  }, '', 'info');
  }
  export function showSalesorderPop(selectedWorkSchedule){
    Swal.fire({
      html:getHTMLForSummaryPopup(
         'SALES ORDER DETAILS',
         [
           
           {label: 'SO DATE', value: selectedWorkSchedule.sales_order_detail.sales_order.order_date},
           {label: 'CUSTOMER P.O NO', value: selectedWorkSchedule.sales_order_detail.sales_order.purchase_order_no},
           {label: 'MODE OF TRANSPORT', value: selectedWorkSchedule.sales_order_detail.sales_order.transport_mode},
           {label: 'SALES ORDER QTY', value: selectedWorkSchedule.sales_order_detail.order_quantity},
           
  
         ])
  }, '', 'info'); 
  }
  export function showProjectrPop(delivery_details){
    Swal.fire({
      html:getHTMLForSummaryPopup(
          'PROJECT/SITE DETAILS',
          [
            {label: 'PROJECT/SITE', value: delivery_details.project_name},
            {label: 'CONTACT NAME', value: delivery_details.contact_person},
            {label: 'MOBILE NUMBER', value: delivery_details.mobile_number},
            {label: 'DESIGNATION', value: delivery_details.contact_designation},
                  ])
  }, '', 'info');   
  }

export function getDeliveryChallanErrorText(errorData) {
  return flattenErrorMessage(errorData) || 'An unexpected error occurred';
}

/** Returns error message string if weighment is invalid; otherwise null. */
export function getWeighmentValidationError(inputs, { requireActualVsDcQty = true } = {}) {
  const tare = Number(inputs?.tare_weight) || 0;
  const net = Number(inputs?.net_weight) || 0;
  const gross = Number(inputs?.gross_weight) || 0;
  const dcQty = Number(inputs?.dc_qty) || 0;

  if (tare < 0 || net < 0 || gross < 0) {
    return 'Weighment weights must be greater than or equal to zero.';
  }
  const expectedNet = Math.round(gross) - Math.round(tare);
  if (Math.round(net) !== expectedNet) {
    return 'Gross Weight must equal Tare Weight + Actual Weight.';
  }
  if (requireActualVsDcQty && dcQty > 0 && !(Math.round(net) > dcQty)) {
    return `Actual/Net Weight (${Math.round(net)}) must be greater than DC Qty (${dcQty}).`;
  }
  return null;
}

export function getVehicleIdFromError(errorData) {
  return errorData?.vehicle_id
    || errorData?.detail?.vehicle_id
    || null;
}

export function isVehicleDocumentExpiryError(errorData) {
  return /Expired \d+ days ago/i.test(getDeliveryChallanErrorText(errorData));
}

export function displayDeliveryChallanSaveError({
  errorData,
  title,
  vehicleId,
  navigate,
  returnTo,
  onBeforeRedirect,
}) {
  const equipmentId = vehicleId || getVehicleIdFromError(errorData);
  const canOpenEquipment = isVehicleDocumentExpiryError(errorData) && equipmentId;
  if (!canOpenEquipment) {
    displayError(errorData, title);
    return;
  }

  const message = getDeliveryChallanErrorText(errorData);
  Swal.fire({
    title,
    icon: 'warning',
    html: `<b><i>${message}</i></b><p style="margin-top:12px">Open the equipment form to update Insurance, FC and Permit dates, then return here to save the delivery challan.</p>`,
    showCancelButton: true,
    confirmButtonText: 'Open Equipment',
    cancelButtonText: 'OK',
    reverseButtons: true,
  }).then((result) => {
    if (result.isConfirmed) {
      onBeforeRedirect?.();
      navigate(`/EquipmentEdit/${equipmentId}/?returnTo=${encodeURIComponent(returnTo)}`, {
        state: { returnTo },
      });
    }
  });
}

const ACTION_BUTTON_STYLE = 'margin:6px;min-width:160px;padding:8px 12px;border:0;border-radius:4px;color:#fff;font-weight:700;cursor:pointer';

export function showWorkScheduleActionDialog({ payload, navigate, returnTo, onBeforeRedirect }) {
  const message = typeof payload === 'string' ? payload : (payload?.message || '');
  const workScheduleId = typeof payload === 'object' ? payload?.work_schedule_id : null;
  const salesOrderId = typeof payload === 'object' ? payload?.sales_order_id : null;
  const actions = Array.isArray(payload?.actions) ? payload.actions : [];
  const showSalesOrder = actions.includes('sales_order') && Boolean(salesOrderId);
  const showGateCheckIn = actions.includes('gate_check_in');
  const showJobCompletion = actions.includes('job_completion') && Boolean(workScheduleId);
  const showWorkScheduleEdit = actions.includes('work_schedule_edit') && Boolean(workScheduleId);
  const hasActionButtons = showSalesOrder || showGateCheckIn || showJobCompletion || showWorkScheduleEdit;

  const actionButtonsHtml = hasActionButtons
    ? `<div id="ws-action-buttons" style="margin-top:16px;display:flex;flex-wrap:wrap;justify-content:center">
        ${showGateCheckIn ? `<button type="button" id="ws-open-check-in" style="${ACTION_BUTTON_STYLE};background:#b45309">Gate Check-in</button>` : ''}
        ${showSalesOrder ? `<button type="button" id="ws-open-sales-order" style="${ACTION_BUTTON_STYLE};background:#0f766e">Sales Order</button>` : ''}
        ${showJobCompletion ? `<button type="button" id="ws-open-job-completion" style="${ACTION_BUTTON_STYLE};background:#1d4ed8">Work Schedule Complete</button>` : ''}
        ${showWorkScheduleEdit ? `<button type="button" id="ws-open-work-schedule" style="${ACTION_BUTTON_STYLE};background:#1e3a8a">Work Schedule Edit</button>` : ''}
      </div>`
    : '';

  Swal.fire({
    icon: 'info',
    title: 'Work Schedule Action Required',
    html: `${String(message || '').replace(/\n/g, '<br>')}${actionButtonsHtml}`,
    showConfirmButton: !hasActionButtons,
    confirmButtonText: 'OK',
    showCancelButton: true,
    cancelButtonText: 'OK',
    width: 560,
    didOpen: () => {
      const go = (path) => {
        onBeforeRedirect?.();
        Swal.close();
        navigateWithReturn(navigate, path, returnTo);
      };
      document.getElementById('ws-open-check-in')?.addEventListener('click', () => {
        go('/CheckIn');
      });
      document.getElementById('ws-open-sales-order')?.addEventListener('click', () => {
        go(`/SalesOrderEdit/${salesOrderId}/`);
      });
      document.getElementById('ws-open-job-completion')?.addEventListener('click', () => {
        go(`/JobCompletion/${workScheduleId}/`);
      });
      document.getElementById('ws-open-work-schedule')?.addEventListener('click', () => {
        go(`/WorkScheduleEdit/${workScheduleId}/`);
      });
    },
  });
}
